import { LOCALIZED_PATHS, localizeRoute } from '../constants/url-constants';

/** Relative URL to the profile page for the given UI locale (e.g. `/fi/profiili`). */
export function buildLocalizedProfileHref(locale: string): string {
  const key = locale in LOCALIZED_PATHS ? (locale as keyof typeof LOCALIZED_PATHS) : 'en';
  return `/${key}${localizeRoute('/profile', key)}`;
}
